export default "__VITE_ASSET__CFmny2oi__"